@if (show) {
  <div
    class="alert"
    [ngClass]="[alertClass ?? '', bottomMargin ? 'mb-3' : 'mb-0']"
    role="alert"
  >
    @if (icon) {
      <div class="alert-icon">
        <i-lucide [name]="icon"></i-lucide>
      </div>
    }
    <div class="alert-message">
      <ng-content></ng-content>
    </div>
    @if (dismissable) {
      <div class="alert-close">
        <button
          data-dd-action-name="alert.close-button"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="show = false"
        ></button>
      </div>
    }
  </div>
}
